import { useTranslation } from 'react-i18next';

import InformationLine from '@/assets/icons/information_line.svg?component';
import { Card, CardDivider, CardHeader } from '@/components/atoms/Card';
import { TextLink } from '@/components/atoms/TextLink';
import TitleIcon from '@/components/atoms/TitleIcon/TitleIcon';
import { MetricSummaryRow } from '@/components/molecules/MetricSummaryRow';
import { localizedDate } from '@/utils/date';

import { getHealthLaksvelOverviewProtocolHref } from '../../../_config/healthProtocolLinks';

import styles from './HealthDashboardInfoPanel.module.scss';

const DASHBOARD_SCORE_KEYS = ['score0', 'score1', 'score2', 'score3'] as const;

interface HealthDashboardInfoPanelProps {
    asOf: string | undefined;
}

export default function HealthDashboardInfoPanel(props: HealthDashboardInfoPanelProps) {
    const { asOf } = props;
    const { t, i18n } = useTranslation('healthModule');

    const lastMeasurementLabel = asOf ? localizedDate(asOf, i18n.language) : undefined;
    const protocolHref = getHealthLaksvelOverviewProtocolHref(i18n.language);

    return (
        <Card
            padding="lg"
            header={
                <CardHeader
                    title={t('dashboard.informationTitle')}
                    level="h3"
                    icon={<TitleIcon icon={InformationLine} />}
                />
            }>
            <div className={styles.panel}>
                <MetricSummaryRow
                    flush
                    label={t('dashboard.lastMeasurementDay')}
                    value={lastMeasurementLabel ?? t('dashboard.notAvailable')}
                />
                <CardDivider />
                <div className={styles.description}>
                    <p className={styles.descriptionLead}>{t('dashboard.laksvelIntro')}</p>
                    <TextLink
                        className={styles.protocolLink}
                        href={protocolHref}
                        target="_blank"
                        rel="noopener noreferrer">
                        {t('dashboard.protocolLinkLabel')}
                    </TextLink>
                    <p className={styles.descriptionBody}>{t('dashboard.laksvelRainbowTrout')}</p>
                    <p className={styles.descriptionBody}>
                        {t('dashboard.laksvelDescriptionBody')}
                    </p>
                    <ul className={styles.scoreList}>
                        {DASHBOARD_SCORE_KEYS.map((scoreKey) => (
                            <li key={scoreKey} className={styles.scoreItem}>
                                {t(`dashboard.${scoreKey}Description`)}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </Card>
    );
}
